import { render, staticRenderFns } from "./sendRecord.vue?vue&type=template&id=680a62f0&scoped=true&"
import script from "./sendRecord.vue?vue&type=script&lang=js&"
export * from "./sendRecord.vue?vue&type=script&lang=js&"
import style0 from "./sendRecord.vue?vue&type=style&index=0&id=680a62f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a62f0",
  null
  
)

export default component.exports